import {
	Button,
	ButtonColorAgainst,
	ButtonSize,
	ButtonVariant,
} from '@/libraries/design/components/button/src/button.tsx';

export type UniformButtonProps = {
	text: string;
	href: string;
	size?: ButtonSize;
	variant?: ButtonVariant;
	colorAgainst?: ButtonColorAgainst;
	mobileSize?: ButtonSize;
	tabletSize?: ButtonSize;
	desktopSize?: ButtonSize;
	xlDesktopSize?: ButtonSize;
};

const UniformButton = ({
	text,
	href,
	size,
	variant,
	colorAgainst,
	mobileSize,
	tabletSize,
	desktopSize,
	xlDesktopSize,
}: UniformButtonProps) => {
	return (
		<Button
			href={href}
			size={size}
			variant={variant}
			colorAgainst={colorAgainst}
			responsiveSize={
				mobileSize &&
				tabletSize &&
				desktopSize &&
				xlDesktopSize && {
					mobile: mobileSize,
					tablet: tabletSize,
					desktop: desktopSize,
					xl_desktop: xlDesktopSize,
				}
			}
			dataEventProps={{
				'data-product-key': 'uniform',
				'data-event-component': 'linkButton',
				'data-event-container': 'button',
				'data-event': 'clicked',
			}}
		>
			{text}
		</Button>
	);
};

export default UniformButton;
